define('services/qualityManagementService',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'lib/bluebird',
    'config',
    'services/apiCore',
    'services/authService',
    'models/Conversation',
    'models/Recording',
    'models/Annotation',
    'models/ConversationSummary',
    'models/PendingEvaluations',
    'util/ObservableModel'
], function (
    _,
    ko,
    $,
    Promise,
    config,
    apiCore,
    authService,
    Conversation,
    Recording,
    Annotation,
    ConversationSummary,
    PendingEvaluations,
    ObservableModel
) {
    'use strict';

    var qualityManagementService = {
        PENDING: "PENDING",
        INPROGRESS : "INPROGRESS",
        FINISHED : "FINISHED",

        getConversation: function (conversationId) {
            return apiCore.v2.get('/conversations/' + conversationId)
            .then(function (response) {
                return new Conversation(response);
            });
        },

        /**
         * getRecordings
         *
         * will retrieve all recordings associated with conversationId that has been passed in
         *
         * @param conversationId
         * @returns {*}
         */
        getRecordings: function (conversationId, formatId) {
            //TODO: Handle multiple recordings per unique conversation Id
            return apiCore.v2.get('/conversations/' + conversationId + '/recordings' + (formatId?'?formatId=' + formatId:''))
                .then(function (response) {
                    //returns one or more recording objects
                    return response;
                });
        },

        getDownloadRecording: function(conversationId, recordingId, formatId, fileName){
            var parameters = {
                'formatId': _.isEmpty(formatId) ? "wav" : formatId,
                'download': 'true',
                'fileName': _.isEmpty(fileName) ? recordingId : fileName
            };
            return apiCore.v2.get('/conversations/' + conversationId + '/recordings/' + recordingId, parameters);
        },

        /**
         * getRecording
         *
         * will retrieve a single recording using the recording object that has been passed into function
         *
         * @param recording
         * @returns {*}
         */
        getRecording: function (recording) {
            return apiCore.v1.get('/conversations/' + recording.conversationId + '/recordings/' +recording.id)
            .then(function (response) {
                return new Recording(response);
            });
        },

        updateRecording: function (recording, options) {
            return apiCore.v2.put('/conversations/'+ recording.conversationId + '/recordings/' + (recording.id ? recording.id : recording.recordingId), recording, options)
            .then(function (response) {
                return new Recording(response);
            });
        },

        createAnnotation: function (recording, annotationText, position) {
            return apiCore.v2.post('/conversations/' + recording.conversationId + '/recordings/' + recording.id + '/annotations', {
                description: annotationText,
                location: position,
                type: 'Bookmark'
            })
            .then(function (response) {
                return new Annotation(response);
            });
        },

        getConversationSummary: function (options, pagingUriAnchor) {

            if(_.isUndefined(pagingUriAnchor)) {
                pagingUriAnchor = "";
            } else {
                pagingUriAnchor = "/" + pagingUriAnchor;
            }

            return apiCore.v1.post('/conversations/query' + pagingUriAnchor, options)
            .then(function (response) {
                var summary = new ConversationSummary();
                var conversations = response;
                ObservableModel.merge(summary, conversations);
                return summary;
            });
        },

        getConversationAttributeNames: function () {
            // TODO: Mock data used by qm policy UI!
            var attributes = ko.observableArray(["shift", "reviewer", "favorite", "flagged"]);
            return Promise.resolve(attributes);
        },

        getRecordingMediaTypes: function() {
            var mediaTypes = [{
                id: 'CALL',
                display: ko.i18n.renderString('qualityManagementService.mediaTypes.call')
            }, {
                id: 'CHAT',
                display: ko.i18n.renderString('qualityManagementService.mediaTypes.chat')
            }];

            return Promise.resolve(ko.observableArray(mediaTypes));
        },

        getConversationDirections: function() {
            var directions = [{
                id: 'INBOUND',
                display: ko.i18n.renderString('qualityManagementService.conversationDirections.inbound')
            }, {
                id: 'OUTBOUND',
                display: ko.i18n.renderString('qualityManagementService.conversationDirections.outbound')
            }];

            return Promise.resolve(ko.observableArray(directions));
        },
        getAssignedEvaluations: function(options) {
            return apiCore.v2.get('/quality/evaluations/query', options)
            .then(function (response) {
                return Promise.resolve(response);
            })
            .then(function (expandedResponse) {
                var pendingEvaluationData = new PendingEvaluations();
                ObservableModel.merge(pendingEvaluationData, expandedResponse);
                return pendingEvaluationData;
            });
        },
        getPendingEvaluations: function(currentUserId) {
            return apiCore.v2.get('/quality/evaluations/query', {
                evaluatorUserId: currentUserId
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .then(function (expandedResponse) {
                var pendingEvaluationData = new PendingEvaluations();
                ObservableModel.merge(pendingEvaluationData, expandedResponse);
                return pendingEvaluationData;
            });
        },

        getConversationEvaluations: function(conversationId, options) {
            options = options || {};
            var params = _.assign({
                expand: "evaluator",
                conversationId: conversationId
            }, options);
            return apiCore.v2.get('/quality/evaluations/query', params)
                .then(function (response) {
                    return response;
                });
        },

        getConversationSurveys: function(conversationId) {
            return apiCore.v2.get('/quality/conversations/' + conversationId + '/surveys')
                .then(function (response) {
                    return response;
                });
        },

        getAgentEvaluations: function(currentUserId, options) {
            var uri = '/quality/evaluations/query';

            options.agentUserId = currentUserId;
            return apiCore.v2.get(uri, options)
                .then(function (response) {
                    var agentEvaluationData = new PendingEvaluations();
                    ObservableModel.merge(agentEvaluationData, response);
                    return agentEvaluationData;
                }
            );
        },
        getAssignedEvaluation: function(conversationId, assignedEvaluationId, options) {
            return apiCore.v2.get('/quality/conversations/' + conversationId + '/evaluations/' + assignedEvaluationId, options);
        },

        deleteEvaluation: function(conversationId, assignedEvaluationId) {
            return apiCore.v2.del('/quality/conversations/' + conversationId + '/evaluations/' + assignedEvaluationId);
        },

        createCalibration: function(calibration) {
            if (!calibration.calibrator){
                calibration.calibrator = {id: authService.principalId()};
            }
            return apiCore.v2.post('/quality/calibrations', calibration );
        },
        getCalibrations: function(options) {
            if (!options) {
                options = {};
            }
            if (!options.calibratorId){
                options.calibratorId = authService.principalId();
            }
            return apiCore.v2.get('/quality/calibrations', options);
        },
        getCalibration: function(calibrationId, options) {
            if (!options) {
                options = {};
            }
            if (!options.calibratorId){
                options.calibratorId = authService.principalId();
            }
            return apiCore.v2.get('/quality/calibrations/' + calibrationId, options);
        },
        putCalibration: function(calibration) {
            if (!calibration.calibratorId){
                calibration.calibrator = {id: authService.principalId()};
            }
            return apiCore.v2.put('/quality/calibrations/' + calibration.id, calibration);
        },
        deleteCalibration: function(calibrationId, options) {
            if (!options) {
                options = {};
            }
            if (!options.calibratorId){
                options.calibratorId = authService.principalId();
            }
            return apiCore.v2.del('/quality/calibrations/' + calibrationId, options);
        },
        updateAssignedEvaluation: function(conversationId, assignedEvaluationId, assignedEvaluation) {
            return apiCore.v2.put('/quality/conversations/' + conversationId + '/evaluations/' + assignedEvaluationId, assignedEvaluation)
            .then(function (response) {
                return response;
            });
        },
        createEvaluation: function(evaluation) {
            return apiCore.v2.post('/quality/conversations/' + evaluation.conversation.id + '/evaluations', evaluation );
        },
        getRecentEvaluatorActivity: function (options) {
            return apiCore.v2.get('/quality/evaluators/activity', options);
        },
        getAgentActivity: function(options) {
            return apiCore.v2.get('/quality/agents/activity', options);
        },
        getAudits: function(conversationId, options){
            return apiCore.v2.get('/quality/conversations/' + conversationId + '/audits', options);
        }
    };
    return qualityManagementService;
});

